import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import {
  _canReceiveDefaultTextFormat,
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';
import { Text } from '@dynatrace/strato-components/typography';

import { subtitleCSS } from './TitleBar.sty.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Subtitle
 * @public
 */
export interface TitleBarSubtitleProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Subtitle slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Subtitle component
 * @public
 */
export const Subtitle = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarSubtitleProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarSubtitleProps = props;
  const childIsText = _canReceiveDefaultTextFormat(props.children);

  return (
    <div
      ref={forwardedRef}
      className={clsx(subtitleCSS, consumerClassName)}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {childIsText ? (
        <Text textStyle="base" as="p">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
});
